import { PutEffect, put, takeLatest } from "redux-saga/effects";
import {
    cityConfigurationReceived,
    currentCityHasRealTimeDataReceived,
    currentCityReceived,
    getCityConfiguration as getCityConfigurationAction
} from "../actions/City";
import {
    GET_CURRENT_CITY,
    GET_CURRENT_CITY_HAS_REAL_TIME_DATA,
    GET_CITY_CONFIGURATION,
    CityConfigurationReceived,
    CurrentCityHasRealTimeDataReceived,
    CurrentCityReceived
} from "../actions/City/types";
import { getRequest, showError } from "../components/commonUtilities";
import { decrypt } from "../Utilities/decryption";
import { GeneratorYieldType } from "../interfaces/ActionReducer/GetMethod/GetResponse";
import axios from "axios";
import { store } from "store";
import { currentApplicationVersion } from "actions";

function* getCurrentCity(): Generator<
    | GeneratorYieldType<CurrentCityReceived["payload"]>
    | GeneratorYieldType<typeof getCityConfiguration>
    | GeneratorYieldType<undefined>
    | Promise<typeof getCityConfigurationAction>,
    void,
    CurrentCityReceived["payload"]["data"]
> {
    try {
        const json = yield axios.get("/api/cityinfo/currentcity/").then((res) => {
            store.dispatch(
                currentApplicationVersion({
                    currentApplicationVersion: res.headers["x-application-version"]
                })
            );
            if (!localStorage.getItem("version")) {
                localStorage.setItem("version", res.headers["x-application-version"]);
            }
            return res.data;
        });

        yield put(currentCityReceived({ data: json }));
        yield put(getCityConfigurationAction());
    } catch (e) {
        showError(e);
    }
}

export function* getCurrentCitySaga() {
    yield takeLatest(GET_CURRENT_CITY, getCurrentCity);
}

function* getCurrentCityHasRealTimeData(): Generator<
    | GeneratorYieldType<CurrentCityHasRealTimeDataReceived["payload"]>
    | Promise<CurrentCityHasRealTimeDataReceived["payload"]>,
    void,
    CurrentCityHasRealTimeDataReceived["payload"]
> {
    try {
        let json = yield getRequest("/api/misc/check_realtime_segments_data/");
        json = decrypt(json);
        yield put(currentCityHasRealTimeDataReceived({ message: json.message }));
    } catch (e) {
        showError(e);
    }
}

export function* getCurrentCityHasRealTimeDataSaga() {
    yield takeLatest(GET_CURRENT_CITY_HAS_REAL_TIME_DATA, getCurrentCityHasRealTimeData);
}

function* getCityConfiguration(): Generator<
    GeneratorYieldType<CityConfigurationReceived["payload"]> | Promise<CityConfigurationReceived>,
    void,
    CityConfigurationReceived["payload"]["data"]
> {
    try {
        let json = yield getRequest("/api/city-configuration/").then(
            (response) => response.results
        );

        json = decrypt(json);

        yield put(cityConfigurationReceived({ data: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getCityConfigurationSaga() {
    yield takeLatest(GET_CITY_CONFIGURATION, getCityConfiguration);
}
